import React from 'react'
import { NavLink } from 'react-router-dom';
import { BsQuestionCircle, BsPerson, BsBorderInner } from 'react-icons/bs';

const Footer = () => {

    const footerData = [
        {title: 'Home', to: '/', icon: <BsBorderInner size='24' />},
        {title: 'FAQ', to: '/faq', icon: <BsQuestionCircle size='24' />},
        {title: 'Akun', to: 'akun', icon: <BsPerson size='24' />},
    ];

    const footerElement = footerData.map((hasil, i) =>
        <NavLink key={i} to={hasil.to} exact={true} className={({ isActive }) => (isActive ? 'text-primary' : 'text-gray-600')}>
            <div className='flex flex-col items-center'>
                {hasil.icon}
                <p className='text-xs mt-1 md:font-normal font-semibold'>{hasil.title}</p>
            </div>
        </NavLink>
    );

    return (
        <div className='max-w-[600px] mx-auto bottom-0 fixed left-0 right-0 border-t flex justify-around items-center space-x-5 py-1 bg-white'>
            {footerElement}
        </div>
    )
}

export default Footer
